import React from "react";
import logoImg from "../assets/logo.svg";
import { Link } from "react-router-dom";

const HomeNav = () => {
	const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);
	return (
		<nav className="bg-white shadow-lg sticky top-0 z-50">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="flex justify-between items-center h-16">
					<div className="flex items-center">
						<div className="flex-shrink-0">
							<span className="!text-2xl font-bold text-primary-600">
								<img
									src={logoImg}
									alt="Elitemindmap"
									width="200px"
									height="64px"
									style={{
										width: "200px",
										height: "64px",
									}}
								/>
							</span>
						</div>
					</div>

					{isDrawerOpen && (
						<div className="fixed inset-0 z-50 flex justify-end">
							{/* Backdrop */}
							<div
								className="absolute inset-0 bg-black/40 transition-opacity"
								onClick={() => setIsDrawerOpen(false)}
							/>

							{/* Drawer panel */}
							<div
								className="relative w-64 max-w-xs bg-white h-full shadow-2xl transform transition-transform duration-300 ease-in-out"
								style={{
									transform: isDrawerOpen
										? "translateX(0)"
										: "translateX(100%)",
								}}
							>
								<button
									onClick={() => setIsDrawerOpen(false)}
									className="absolute top-4 left-4 !text-gray-600 hover:text-gray-800"
								>
									<span className="material-symbols-outlined">
										close
									</span>
								</button>

								<nav className="mt-16 flex flex-col gap-4 px-6">
									{[
										"Home",
										"About Us",
										"Gallery",
										"Franchise",
										"Contact Us",
									].map((item) => (
										<a
											key={item}
											href={`#${
												item.toLowerCase().split(" ")[0]
											}`}
											className="block !no-underline !text-gray-800 hover:text-primary-500 text-lg font-medium transition-colors duration-200"
											onClick={() =>
												setIsDrawerOpen(false)
											}
										>
											{item}
										</a>
									))}

									<Link
										to={"/reviews"}
										className="block !no-underline
										!text-gray-800 hover:text-primary-500
										text-lg font-medium transition-colors
										duration-200"
										onClick={() => setIsDrawerOpen(false)}
									>
										Reviews
									</Link>

									<Link
										className="login-btn block !text-gray-800 hover:text-primary-500 text-lg !no-underline font-medium transition-colors duration-200"
										to="/signin"
									>
										Login
									</Link>
								</nav>
							</div>
						</div>
					)}

					<div className="hidden md:block">
						<div className="ml-10 flex items-baseline gap-4 !space-x-6">
							<a
								href="#home"
								className="block !no-underline !text-gray-800 hover:!text-primary-500 text-lg font-medium transition-colors duration-200"
							>
								Home
							</a>
							<a
								href="#about"
								className="block !no-underline !text-gray-800 hover:!text-primary-500 text-lg font-medium transition-colors duration-200"
							>
								About
							</a>
							<a
								href="#gallery"
								className="block !no-underline !text-gray-800 hover:!text-primary-500 text-lg font-medium transition-colors duration-200"
							>
								Gallery
							</a>
							<a
								href="#franchise"
								className="block !no-underline !text-gray-800 hover:!text-primary-500 text-lg font-medium transition-colors duration-200"
							>
								Franchise
							</a>
							<a
								href="#contact"
								className="block !no-underline !text-gray-800 hover:!text-primary-500 text-lg font-medium transition-colors duration-200"
							>
								Contact Us
							</a>
							<Link
								to={"/reviews"}
								className="block !no-underline !text-gray-800 hover:!text-primary-500 text-lg font-medium transition-colors duration-200"
								onClick={() => setIsDrawerOpen(false)}
							>
								Reviews
							</Link>
						</div>
					</div>
					<div className="hidden md:flex items-center space-x-4">
						<button className="login-btn !bg-gradient-to-r !from-orange-400 !to-pink-400 !text-white !px-4 !py-2 !rounded-full !font-semibold hover:!shadow-lg !transform hover:!scale-105 !transition-all !duration-200">
							<Link
								to="/signin"
								className="!no-underline !text-white"
							>
								Login
							</Link>
						</button>
					</div>
					<div className="md:hidden">
						<button
							className="!text-gray-700 hover:!text-primary-500 focus:!outline-none"
							onClick={() => {
								setIsDrawerOpen(!isDrawerOpen);
							}}
						>
							<span className="material-symbols-outlined">
								menu
							</span>
						</button>
					</div>
				</div>
			</div>
		</nav>
	);
};

export default HomeNav;
